<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-08 09:55:07
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:50:33
 * @name: 目录
 * @Description: 目录
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\tree-list.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="treeList">
    <el-tree
      ref="tree"
      :expand-on-click-node="false"
      :data="mailList.treeData"
      node-key="id"
      :default-expanded-keys="[defaultOpen]"
      :highlight-current="true"
      :props="defaultProps"
      @node-click="handleNodeClick"
    ></el-tree>
  </div>
</template>
<script>
import { debounceation } from "@/utils/decorator";
export default {
  name: "mailList-treeList",
  props: {
    mailList: {
      type: Object,
    },
  },
  data() {
    return {
      defaultOpen: 1, //树控件打开节点
      defaultProps: {
        //树控件数据绑定规则
        children: "child",
        label: "name",
      },
      loading: "", //加载中控件
    };
  },
  watch: {
    // 激活节点id变化,更新树控件状态
    "mailList.treeNode.id": {
      handler(nv, ov) {
        this.defaultOpen = nv;
        this.$refs.tree.setCurrentKey(nv);
      },
      immediate: false,
      deep: true,
    },
    // 树内容变化,更新树控件状态
    "mailList.treeData": {
      handler(nv, ov) {
        this.$nextTick(() => {
          this.defaultOpen = this.mailList.treeNode.id;
          this.$refs.tree.setCurrentKey(this.mailList.treeNode.id);
        });
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.getTreeList();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取树内容,并默认选中第一行
     */
    getTreeList() {
      this.loading = this.$commonUtil.loading("获取通讯录中...");
      this.mailList
        .getTreeList()
        .then((res) => {
          const treeDataItem = this.mailList.treeData[0];
          this.defaultOpen = treeDataItem?.id ?? "";
          this.mailList.treeNode = treeDataItem ?? {};
        })
        .finally(() => {
          this.loading.close();
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击树节点
     * @param {Object} data 节点数据
     */
    @debounceation(300)
    handleNodeClick(data) {
      this.mailList.activeTreeNode(data);
    },
  },
};
</script>
<style lang="scss" scoped>
.treeList {
  width: 300px;
  border-right: 1px solid $Vars-border-first-color;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 30px 0;
  overflow: auto;
  //解决溢出显示滚动条
  /deep/ .el-tree-node.is-expanded > .el-tree-node__children {
    display: inline;
  }
  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background: $Vars-normal-color;
    color: $Vars-base-color-white;
  }
}
</style>